import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { isEmpty } from '@app/util/util';

import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import {
  TagRatingMaxValue, TagRatingMinValue, TagRatingSize, TagRatingType, TagRatingValueRange
} from '@design-system/components/molecules/tag-rating/entities/tag-rating.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';

@Component({
  selector: 'app-ds-tag-rating',
  templateUrl: './tag-rating.component.html',
  styleUrls: ['./tag-rating.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
  ]
})
export class TagRatingDsComponent {

  @Input() size = TagRatingSize.LG;
  @Input() type = TagRatingType.Score;
  @Input() value: TagRatingValueRange = 0;
  @Input() title: string;
  @Input() description: string;
  @Input() range: string;

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontColor = TypographyColor;

  public readonly rangeFontSize = TypographyFontSize.Minor;
  public readonly descriptionFontSize = TypographyFontSize.XXS;

  constructor() { }

  get infoIsEnabled(): boolean {
    return this.titleIsEnabled || this.descriptionIsEnabled;
  }

  get titleIsEnabled(): boolean {
    return this.type === TagRatingType.Rating && !isEmpty(this.title);
  }

  get scoreRangeIsEnabled(): boolean {
    return this.size === TagRatingSize.LG && !isEmpty(this.range);
  }

  get labelIsEnabled(): boolean {
    return this.type === TagRatingType.Label;
  }

  get descriptionIsEnabled(): boolean {
    return this.type === TagRatingType.Rating && this.size === TagRatingSize.LG && !isEmpty(this.description);
  }

  get score(): string {
    return (this.value < TagRatingMaxValue && this.value > TagRatingMinValue) ? (
      (this.value % 1 === 0) ? `${this.value}.0` : `${this.value}`
    ) : `${this.value}`;
  }

  get tagLabel(): string {
    return this.labelIsEnabled ? this.title : this.score;
  }

  get titleFontSize(): TypographyFontSize {
    return this.size === TagRatingSize.SM ? TypographyFontSize.XXS : TypographyFontSize.XS;
  }

  get scoreFontSize(): TypographyFontSize {
    return this.size === TagRatingSize.SM ? TypographyFontSize.Minor :
      this.size === TagRatingSize.RG ? TypographyFontSize.XXXS : TypographyFontSize.LG;
  }

}
